import { Component } from '@angular/core';
import { Title } from '@angular/platform-browser';

/**
 * Mirrors FGR Hub's account-404 NotFoundPage (same copy + layout): the landing
 * page for permission-denied route guards (NgxPermissionsGuard `redirectTo`
 * targets and CapabilityGuard denials). The copy is deliberately ambiguous
 * between "unavailable" and "no permission". Gated by authentication only — a
 * capability gate here would loop.
 */
@Component({
  selector: 'ot-page-not-found',
  templateUrl: './page-not-found.component.html',
  styleUrls: ['./page-not-found.component.scss'],
})
export class PageNotFoundComponent {
  constructor(title: Title) {
    title.setTitle('Page Not Found');
  }
}
